import { useSelector } from "react-redux"

const useTrees = ()=>{
    return useSelector(state => state.newTrees.data)
}

export default useTrees